<template>
  <div id="trashbin-page">
    <!-- page header component -->
    <page-header-component icon="bi bi-trash" title="Trash Bin" :hideTopik="true" />
    <!-- page component -->
    <transition name="block">
      <div v-show="mounted" class="row">
        <div class="col-md-12 px-gap">
          <div class="bg-white rounded p-3 shade">
            <div class="row">
              <div class="col-md-8 col-sm-12">
                <div class="pull-left">
                  <h4 class="m-b-0">Daftar Mentions Dihapus</h4>
                  <p class="small hint-text">
                    Menampilkan daftar Mentions yang telah dihapus sebelumnya
                  </p>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-8">
                <div class="d-flex">
                  <div class="form-group input-group input-group-right transparent m-b-0 m-t-0 mr-2 w-25" id="post-sort">
                    <select id="filter-terbaru" name="sort" v-model="sort" class="form-control form-custom">
                      <option value="esmr">Terpopuler</option>
                      <option value="date">Terbaru</option>
                      <option value="dateOld">Terlama</option>
                      <option value="engagement">Keterlibatan</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text transparent">
                        <i class="bi bi-sort-down-alt" style="font-size: 18px"></i>
                      </span>
                    </div>
                  </div>
                  <div class="form-group input-group input-group-right transparent m-b-0 m-t-0 mr-2 w-25"
                    id="post-per-page">
                    <select id="filter-halaman" name="sort" v-model="per_page" class="form-control form-custom">
                      <option value="10">10 Postingan per Halaman</option>
                      <option value="25">25 Postingan per Halaman</option>
                      <option value="50">50 Postingan per Halaman</option>
                      <option value="100">100 Postingan per Halaman</option>
                      <option value="500">500 Postingan per Halaman</option>
                      <option value="1000">1000 Postingan per Halaman</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text transparent">
                        <i class="bi bi-file-earmark-break"></i>
                      </span>
                    </div>
                  </div>
                  <form action="#" id="post-search-form" @submit.prevent="searchPost" class="mr-2 w-50">
                    <div class="form-group-sm input-group input-group-right">
                      <input id="cari-kata-kunci" type="text" placeholder="Cari..." v-model="search"
                        class="form-control form-custom" />
                      <div class="input-group-append">
                        <span class="input-group-text complete" @click="searchPost" style="cursor: pointer; border: none">
                          <i class="bi bi-search"></i>
                        </span>
                        <span v-if="isFilter" @click="resetFilter" class="input-group-text danger"
                          style="cursor: pointer">
                          <i class="bi bi-trash"></i>
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div v-if="posts != null" class="col-md-4" align="right">
                <div class="d-flex">
                  <button v-if="(isAdmin || isUser) && is_checked" @click="restoreChecked" aria-label=""
                    class="btn btn-success btn-icon-left m-r-5 ml-auto" type="button">
                    <i class="bi bi-recycle" />
                    <span class="">Kembalikan Yang Ditandai</span>
                  </button>
                  <button v-if="(isAdmin || isUser) && is_checked && posts.length > 0" @click="deleteChecked"
                    aria-label="" class="btn btn-danger btn-icon-left" type="button">
                    <i class="bi bi-trash"></i>
                    <span class="">Hapus Yang Ditandai</span>
                  </button>
                  <button v-else-if="(isAdmin || isUser) && posts.length > 0" aria-label="" @click="deleteAll"
                    class="btn btn-danger btn-icon-left ml-auto" type="button" id="delete-permanent-all">
                    <i class="bi bi-trash"></i>
                    <span class="">Hapus Semua</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="is_loading">
              <loader-component />
            </div>
            <div v-else class="row" id="post-wrapper">
              <div class="col-md-12 col-sm-12 col-lg-12" v-if="posts && posts.length > 0">
                <deleted-post-item-component v-for="(post, index) in posts" :key="index" :post="post" :is_pers="false"
                  :topics="topics" :is_trashbin="true" class="w-100" />
                <div>
                  <pagination-component v-if="page_info != null" :key="pagination_key" class="pull-right"
                    :data="page_info" :goto="true" />
                </div>
              </div>
              <div v-else class="col-md-12 col-sm-12 col-lg-12">
                <div class="alert alert-danger mt-3" id="errorApiEl" role="alert" align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                  Silahkan lakukan pencarian dengan parameter lain
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- tour component -->
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import loader from "@/views/components/loader.vue";
import deleted_post_item from "@/views/components/trashbin/deleted_post_item.vue";
import pagination from "@/views/components/pagination.vue";
import swal from "sweetalert";

export default {
  name: "TrashBin",
  title: "Trash Bin | Sibernetik",
  components: {
    "page-header-component": page_header,
    "loader-component": loader,
    "deleted-post-item-component": deleted_post_item,
    "pagination-component": pagination,
  },
  data() {
    return {
      posts: null,
      topics: null,
      item_checked: [],
      is_checked: false,
      page_info: null,
      isFilter: false,
      pagination_key: 0,
      is_loading: true,
      id_project: this.$store.getters.user.id_project,
      tour_steps: [],
      per_page: this.page_info ? this.page_info.limit : 10,
      sort: "sort" in this.$route.query ? this.$route.query.sort : "date",
      search: this.$route.query.q ? atob(this.$route.query.q) : null,
      mounted: false,
    };
  },
  methods: {
    getData: function () {
      this.is_loading = true;
      this.posts = null;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api;
      if (query) {
        api =
          process.env.VUE_APP_API_URL +
          "trash-bin/" +
          this.id_project +
          "?" +
          query;
      } else {
        api = process.env.VUE_APP_API_URL + "trash-bin/" + this.id_project;
      }

      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.posts = response.data.posts;
            this.page_info = response.data.page_info;
            this.pagination_key++;
          } else {
            this.posts = [];
            this.page_info = null;
          }
        })
        .catch(() => {
          this.posts = [];
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 204) {
            this.topics = {};
          } else {
            this.topics = response.data;
          }
        })
        .catch(() => {
          this.topics = {};
        })
        .finally(() => {
          this.getData();
        });
    },
    restoreChecked: function () {
      event.preventDefault();
      let params = {
        _id: this.item_checked,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan mengembalikan posting yang ditandai.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-restore-many";
          this.$http
            .post(api, params)
            .then((response) => {
              if (response.status == 200) {
                this.item_checked = [];
                this.getData();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dikembalikan.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal mengembalikan data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function () {
              swal(
                "Error!",
                "Terjadi kesalahan saat mengembalikan posting. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    deleteChecked: function () {
      event.preventDefault();
      let params = {
        _id: this.item_checked,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus posting yang ditandai. Setelah dihapus permanen, posting tidak akan bisa dikembalikan.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-perma-delete-many";
          this.$http
            .post(api, params)
            .then((response) => {
              if (response.status == 200) {
                this.item_checked = [];
                $("input:checkbox").removeAttr("checked");
                this.getData();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function () {
              swal(
                "Error!",
                "Terjadi kesalahan saat menghapus posting. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    deleteAll: function () {
      event.preventDefault();
      let params = {
        id_project: this.id_project,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus semua posting. Setelah dihapus permanen, posting tidak akan bisa dikembalikan.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-empty-bin";
          this.$http
            .post(api, params)
            .then((response) => {
              if (response.status == 200) {
                this.item_checked = [];
                this.getData();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function () {
              swal(
                "Error!",
                "Terjadi kesalahan saat menghapus posting. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    searchPost() {
      let text = this.search;
      if ("q" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.q = btoa(text);
        if (text == "") {
          this.deleteParam("q");
        } else {
          queries.page = 1;
          this.$router.replace({ query: queries });
          this.isFilter = true;
        }
      } else {
        if (text) {
          this.isFilter = true;
          this.$router.replace({
            query: Object.assign({}, this.$route.query, { q: btoa(text) }),
          });
        }
      }
    },
    resetFilter() {
      this.isFilter = false;
      this.search = "";
      this.deleteParam("q");
    },
    deleteParam: function (key) {
      let queries = this.$route.query;
      delete queries[key];
      let self = this;
      let current_path = this.$route.path;
      this.$router
        .replace(current_path)
        .then(self.$router.replace({ query: queries }));
    },
  },
  watch: {
    item_checked: function () {
      if (this.item_checked.length > 0) {
        this.is_checked = true;
      } else {
        this.is_checked = false;
      }
    },
    $route() {
      this.getData();
    },
    per_page(item) {
      if ("items" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.items = item;
        this.$router.replace({ query: queries });
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { items: item }),
        });
      }
    },
    sort(sort_by) {
      if ("sort" in this.$route.query) {
        if (this.$route.query.sort != sort_by) {
          let queries = JSON.parse(JSON.stringify(this.$route.query));
          queries.sort = sort_by;
          this.$router.replace({ query: queries });
        }
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { sort: sort_by }),
        });
      }
      this.sort = sort_by;
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2) {
        return true;
      }
      return false;
    },
    isUser: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 3) {
        return true;
      }
      return false;
    },
  },
  created: function () {
    if ("q" in this.$route.query) {
      this.isFilter = true;
    }
    this.getTopic();
  },
  mounted: function () {
    this.mounted = true;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );

    let v_step = [];
    v_step[0] = {
      target: "#filter-terbaru",
      header: {
        title: "Filter Waktu",
      },
      content: "Pilih salahsatu untuk melakukan filter berdasarkan waktu",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#filter-halaman",
      header: {
        title: "Filter Halaman",
      },
      content:
        "Pilih salahsatu untuk melakukan filter berdasarkan halaman. Jumlah data yang akan ditampilkan sesuai dengan filter halaman yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#cari-kata-kunci",
      header: {
        title: "Cari data trashbin",
      },
      content: "Masukkan kata kunci untuk mencari data pada trashbin",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#delete-permanent-all",
      header: {
        title: "Hapus Permanen",
      },
      content:
        "Menghapus semua postingan yang ada di Trash Bin secara permanen. Anda tidak dapat mengembalikan postingan setelah melakukan hapus permanen.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: ".visit-btn",
      header: {
        title: "Kunjungi Postingan",
      },
      content: "Mengunjungi sumber asli sebuah postingan.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: ".restore-btn",
      header: {
        title: "Kembalikan Postingan",
      },
      content:
        "Mengembalikan postingan yang telah dihapus ke halaman mentions.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: ".delete-btn",
      header: {
        title: "Hapus Permanen Postingan",
      },
      content: "Menghapus postingan secara permanen.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: ".item-checkbox",
      header: {
        title: "Tandai Postingan",
      },
      content:
        "Anda dapat menandai postingan untuk melakukan aksi secara masal terhadap post yang ditandai.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>
